var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrandIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 14,
    r: 1,
    fill: "#f1bc19"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 38,
    fill: "#f9dbd2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 16,
    r: 4,
    fill: "#f1bc19"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 26,
    r: 2,
    fill: "#ee3e54"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 77,
    r: 2,
    fill: "#fbcd59"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 78,
    r: 4,
    fill: "#fbcd59"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 83,
    r: 2,
    fill: "#ee3e54"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.483,
    cy: 78.517,
    r: 2.483,
    fill: "#fff"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 48,
    r: 1,
    fill: "#fff"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 31,
    r: 1,
    fill: "#f1bc19"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 45,
    r: 2,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#e1e0d8",
    d: "M66.719,73H35.281C31.26,73,28,69.74,28,65.719V34.281C28,30.26,31.26,27,35.281,27h31.438 C70.74,27,74,30.26,74,34.281v31.438C74,69.74,70.74,73,66.719,73z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#00a5a5",
    d: "M66.719,73H35.281C31.26,73,28,69.74,28,65.719V34.281C28,30.26,31.26,27,35.281,27h31.438 C70.74,27,74,30.26,74,34.281v31.438C74,69.74,70.74,73,66.719,73z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#472b29",
    d: "M66.719,73.7H35.281c-4.401,0-7.981-3.58-7.981-7.981V34.281c0-4.401,3.58-7.981,7.981-7.981h31.438 c4.401,0,7.981,3.58,7.981,7.981v31.438C74.7,70.12,71.12,73.7,66.719,73.7z M35.281,27.7c-3.629,0-6.581,2.952-6.581,6.581v31.438 c0,3.629,2.952,6.581,6.581,6.581h31.438c3.629,0,6.581-2.952,6.581-6.581V34.281c0-3.629-2.952-6.581-6.581-6.581H35.281z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#472b29",
    d: "M31.5,40.167c-0.276,0-0.5-0.224-0.5-0.5v-4.333C31,32.393,33.393,30,36.333,30h14 c0.276,0,0.5,0.224,0.5,0.5s-0.224,0.5-0.5,0.5h-14C33.943,31,32,32.944,32,35.333v4.333C32,39.943,31.776,40.167,31.5,40.167z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#472b29",
    d: "M42.583,70h-6.25C33.393,70,31,67.607,31,64.667V44.333c0-0.276,0.224-0.5,0.5-0.5 s0.5,0.224,0.5,0.5v20.333C32,67.056,33.943,69,36.333,69h6.25c0.276,0,0.5,0.224,0.5,0.5S42.859,70,42.583,70z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#472b29",
    d: "M65.667,70h-19.75c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h19.75 C68.057,69,70,67.056,70,64.667v-5.083c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5v5.083C71,67.607,68.607,70,65.667,70z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#472b29",
    d: "M70.5,56.167c-0.276,0-0.5-0.224-0.5-0.5V35.333C70,32.944,68.057,31,65.667,31h-2.75 c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h2.75C68.607,30,71,32.393,71,35.333v20.333C71,55.943,70.776,56.167,70.5,56.167z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#472b29",
    d: "M59.5,31h-6.25c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h6.25c0.276,0,0.5,0.224,0.5,0.5 S59.776,31,59.5,31z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M65,53h-5.068l-6.6-11l2.383-3.971c0.568-0.947,0.262-2.176-0.686-2.744 c-0.948-0.568-2.176-0.262-2.744,0.686L51,38.113l-1.285-2.142c-0.568-0.947-1.798-1.253-2.744-0.686 c-0.947,0.568-1.254,1.797-0.686,2.744L48.668,42l-6.6,11H37c-1.104,0-2,0.896-2,2s0.896,2,2,2h2.668l-2.383,3.971 c-0.568,0.947-0.262,2.176,0.686,2.744C38.293,63.908,38.647,64,38.998,64c0.68,0,1.342-0.346,1.717-0.971L44.332,57h13.335 l3.617,6.029C61.66,63.654,62.322,64,63.002,64c0.351,0,0.705-0.092,1.027-0.285c0.947-0.568,1.254-1.797,0.686-2.744L62.332,57 H65c1.104,0,2-0.896,2-2S66.104,53,65,53z M46.732,53L51,45.887L55.268,53H46.732z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#472b29",
    d: "M63.002,64.25c-0.799,0-1.521-0.408-1.932-1.092l-3.544-5.908H44.474l-3.544,5.908 c-0.411,0.684-1.133,1.092-1.932,1.092c-0.406,0-0.807-0.111-1.156-0.321c-0.515-0.309-0.879-0.801-1.024-1.384 c-0.146-0.583-0.056-1.188,0.253-1.703l2.156-3.592H37c-1.24,0-2.25-1.009-2.25-2.25s1.01-2.25,2.25-2.25h4.926L48.376,42 l-2.306-3.842c-0.309-0.515-0.398-1.12-0.253-1.703c0.146-0.583,0.51-1.074,1.024-1.384c1.068-0.638,2.449-0.291,3.088,0.771 L51,37.627l1.07-1.785c0.64-1.062,2.021-1.409,3.088-0.771c0.515,0.31,0.879,0.801,1.024,1.384 c0.146,0.583,0.056,1.188-0.253,1.703L53.624,42l6.45,10.75H65c1.24,0,2.25,1.009,2.25,2.25s-1.01,2.25-2.25,2.25h-2.227 l2.156,3.592c0.309,0.515,0.398,1.12,0.253,1.703c-0.146,0.583-0.51,1.074-1.024,1.384C63.809,64.139,63.408,64.25,63.002,64.25z M44.332,56.75h13.336c0.088,0,0.169,0.046,0.215,0.121l3.617,6.029c0.318,0.532,0.88,0.849,1.502,0.849 c0.315,0,0.627-0.086,0.898-0.25c0.827-0.496,1.097-1.573,0.6-2.401l-2.383-3.971c-0.046-0.077-0.047-0.173-0.003-0.252 c0.045-0.079,0.128-0.127,0.218-0.127H65c0.965,0,1.75-0.785,1.75-1.75s-0.785-1.75-1.75-1.75h-5.067 c-0.088,0-0.169-0.046-0.215-0.121l-6.601-11c-0.047-0.079-0.047-0.178,0-0.257l2.383-3.971c0.497-0.828,0.228-1.905-0.6-2.401 c-0.826-0.495-1.904-0.228-2.4,0.6l-1.285,2.142c-0.092,0.15-0.338,0.15-0.43,0L49.5,36.099c-0.496-0.827-1.574-1.096-2.4-0.6 c-0.827,0.496-1.097,1.573-0.6,2.401l2.383,3.971c0.047,0.079,0.047,0.178,0,0.257l-6.601,11 c-0.046,0.075-0.127,0.121-0.215,0.121H37c-0.965,0-1.75,0.785-1.75,1.75s0.785,1.75,1.75,1.75h2.668 c0.09,0,0.173,0.048,0.218,0.127c0.044,0.078,0.043,0.175-0.003,0.252L37.5,61.099c-0.497,0.828-0.228,1.905,0.6,2.401 c0.271,0.163,0.583,0.25,0.898,0.25c0.622,0,1.184-0.318,1.502-0.849l3.617-6.029C44.163,56.796,44.244,56.75,44.332,56.75z M55.268,53.25h-8.535c-0.09,0-0.173-0.048-0.218-0.127c-0.044-0.078-0.043-0.175,0.003-0.252l4.268-7.113 c0.092-0.15,0.338-0.15,0.43,0l4.268,7.113c0.046,0.077,0.047,0.174,0.003,0.252C55.44,53.202,55.357,53.25,55.268,53.25z M47.174,52.75h7.652L51,46.373L47.174,52.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#472b29",
    d: "M52.603,43.453c-0.044,0-0.089-0.011-0.129-0.036c-0.118-0.071-0.156-0.225-0.085-0.343l0.71-1.183 c0.07-0.119,0.225-0.157,0.343-0.086c0.118,0.071,0.156,0.225,0.085,0.343l-0.71,1.183C52.77,43.41,52.688,43.453,52.603,43.453z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#472b29",
    d: "M50.938,46.229c-0.044,0-0.088-0.011-0.129-0.036c-0.118-0.071-0.156-0.225-0.086-0.343 l1.156-1.927c0.071-0.119,0.223-0.157,0.344-0.086c0.118,0.071,0.156,0.225,0.086,0.343l-1.156,1.927 C51.105,46.186,51.022,46.229,50.938,46.229z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#472b29",
    d: "M57.729,57.354c-0.084,0-0.167-0.043-0.214-0.12l-2.521-4.146 c-0.071-0.118-0.034-0.272,0.084-0.344c0.118-0.071,0.271-0.035,0.344,0.084l2.521,4.146c0.071,0.118,0.034,0.272-0.084,0.344 C57.818,57.343,57.774,57.354,57.729,57.354z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#472b29",
    d: "M44.578,57.252h-5c-0.138,0-0.25-0.112-0.25-0.25s0.112-0.25,0.25-0.25h5 c0.138,0,0.25,0.112,0.25,0.25S44.716,57.252,44.578,57.252z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandIcon);
export default __webpack_public_path__ + "static/media/BrandIcon.e434cffee331d8303b4e403b7f7edfd8.svg";
export { ForwardRef as ReactComponent };